export default __webpack_public_path__ + "static/media/banner_po_en@2x.e6415131.png";